export default __webpack_public_path__ + "static/media/ao.9b9066f2.jpg";